import { namespaces } from '@common'

export const namespace = namespaces.card.value
export const schema = 'cardRewardSchema'
export const backendDocType = 'RewardCard'
export const docPrivilege = 'card'
